import baseConfig from '@config/base.config';
import cookieUtils from '@utils/cookie.utils';

export default function useUserInfo() {
    const {
        ACCOUNT_ID,
        ACCOUNT_EMAIL,
        ACCOUNT_SIGNUP_SOURCE,
        ACCOUNT_REGION,
        ACCOUNT_I18N,
        ACCOUNT_USERNAME
    } = baseConfig;

    return {
        id: (localStorage.getItem(ACCOUNT_ID) as string) || cookieUtils.getItem(ACCOUNT_ID),
        email:
            (localStorage.getItem(ACCOUNT_EMAIL) as string) || cookieUtils.getItem(ACCOUNT_EMAIL),
        signupSource:
            (localStorage.getItem(ACCOUNT_SIGNUP_SOURCE) as 'ptengine' | 'ptx') ||
            cookieUtils.getItem(ACCOUNT_SIGNUP_SOURCE),
        i18n: (localStorage.getItem(ACCOUNT_I18N) as string) || cookieUtils.getItem(ACCOUNT_I18N),
        name:
            (localStorage.getItem(ACCOUNT_USERNAME) as string) ||
            cookieUtils.getItem(ACCOUNT_USERNAME),
        region:
            (localStorage.getItem(ACCOUNT_REGION) as string) || cookieUtils.getItem(ACCOUNT_REGION)
    };
}
